export function getPythonDocumentKindInfo(state) {
    const editorKind = state.kind === 'glyph-filter' ? 'glyph-filter' : 'general-script';
    if (state.path && !state.isModified) {
        return {
            kind: editorKind,
            editorKind,
            confidence: 'saved-path',
            message: `Document kind is authoritative from saved path ${state.path}.`
        };
    }
    const hasFilterFunction = /^\s*def\s+classify_glyph\s*\(\s*glyph\s*\)\s*:/m.test(state.content || '');
    if (hasFilterFunction) {
        return {
            kind: 'glyph-filter',
            editorKind,
            confidence: 'content-inferred',
            message: state.path
                ? 'This buffer has unsaved edits and defines classify_glyph(glyph), so it is treated as a Glyph Overview filter until saved.'
                : 'Unsaved buffer has no saved Counterpunch/Filters path yet, but it defines classify_glyph(glyph), so it is treated as a Glyph Overview filter.'
        };
    }
    return {
        kind: null,
        editorKind,
        confidence: 'unclassified-unsaved',
        message: state.path
            ? 'This buffer has unsaved edits and no longer defines classify_glyph(glyph), so it is not treated as a Glyph Overview filter until saved.'
            : `Unsaved buffer has no saved Counterpunch/Filters path and does not define classify_glyph(glyph), so it is not treated as a Glyph Overview filter; editor fallback is ${editorKind}, but callers must not treat that as authoritative.`
    };
}
